<template>
  <div>
    <BaseYearInput
      v-model="years"
      is-range
    />
  </div>
</template>

<script>
import BaseYearInput from '@/components/base/YearInput';

export default {
  components: {
    BaseYearInput,
  },
  data() {
    return {
      years: {
        start: null,
        end: null,
      },
    };
  },
};
</script>

<style lang="scss" module>
.view {
  flex-grow: 1;
}
</style>
